export function getCurrentSchoolYear(startMonth: number = 9, startDay: number = 1): number {
  const now = new Date();
  const currentMonth = now.getMonth() + 1;
  const currentDay = now.getDate();
  const currentYear = now.getFullYear();

  if (currentMonth > startMonth || (currentMonth === startMonth && currentDay >= startDay)) {
    return currentYear;
  } else {
    return currentYear - 1;
  }
}

export function getSchoolYearLabel(year: number): string {
  return `${year}-${year + 1}`;
}

export function getSchoolYearStart(year: number, startMonth: number = 9, startDay: number = 1): Date {
  return new Date(year, startMonth - 1, startDay);
}

export function getSchoolYearEnd(year: number, startMonth: number = 9, startDay: number = 1): Date {
  const endMonth = startMonth - 1;
  const endDay = startDay - 1;

  if (endDay === 0) {
    const lastDayOfPrevMonth = new Date(year + 1, endMonth, 0).getDate();
    return new Date(year + 1, endMonth - 1, lastDayOfPrevMonth, 23, 59, 59, 999);
  }

  return new Date(year + 1, endMonth, endDay, 23, 59, 59, 999);
}

export function isInSchoolYear(date: Date, year: number, startMonth: number = 9, startDay: number = 1): boolean {
  const start = getSchoolYearStart(year, startMonth, startDay);
  const end = getSchoolYearEnd(year, startMonth, startDay);
  return date >= start && date <= end;
}

export function getSchoolYearMonth(date: Date, startMonth: number = 9): number {
  const month = date.getMonth() + 1;
  if (month >= startMonth) {
    return month - startMonth + 1;
  } else {
    return month + (12 - startMonth) + 1;
  }
}

const monthNames = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
];

export function getSchoolMonths(startMonth: number = 9): Array<{ number: number; name: string; calendarMonth: number }> {
  const months = [];
  for (let i = 0; i < 12; i++) {
    const calendarMonth = ((startMonth - 1 + i) % 12) + 1;
    months.push({
      number: i + 1,
      name: monthNames[calendarMonth - 1],
      calendarMonth
    });
  }
  return months;
}

export const schoolMonths = getSchoolMonths(9);

export function getSchoolYearMonths(year: number, startMonth: number = 9): Array<{ month: number; year: number }> {
  const months = [];
  for (let i = 0; i < 12; i++) {
    const month = ((startMonth - 1 + i) % 12) + 1;
    const yearOffset = startMonth + i > 12 ? 1 : 0;
    months.push({ month, year: year + yearOffset });
  }
  return months;
}
